export default "__VITE_ASSET__B$BsAFB6__"